import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import css from "./AdminPage.module.css";
import { Head } from "../../utils/Head";
import { Input } from "../../components/common/Input";
import { UserContext } from "../../context/UserContext";
import { doc, setDoc } from "firebase/firestore";
import { db } from "../../services/firebaseConfig";
import { InputArea } from "../../components/common/InputArea";

export const MeetingEdit = () => {
  const { userData } = useContext(UserContext);
  const { state } = useLocation();
  const navigate = useNavigate();
  const [status, setStatus] = useState("");
  const [meetingType, setMeetingType] = useState("");
  const [moderatorOnline, setModeratorOnline] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [schedule, setSchedule] = useState("");
  const [participants, setParticipants] = useState([]);
  const [participantInput, setParticipantInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [meetingUrl, setMeetingUrl] = useState("");

  useEffect(() => {
    if (state) {
      setStatus(state.status);
      setMeetingType(state.type);
      setModeratorOnline(state.moderatorOnline);
      setTitle(state.title);
      setDescription(state.description);
      setSchedule(state.scheduleFor);
      setParticipants(state.participants || []);
      setMeetingUrl(state?.meetingUrl || "");
    }
  }, [state]);

  function handleTagKeyDown(e) {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();

      let email = participantInput.trim().replace(",", "");

      if (!email) return;

      // Evita duplicados
      if (participants.includes(email)) {
        setParticipantInput("");
        return;
      }

      setParticipants([...participants, email]);
      setParticipantInput("");
    }
  }

  async function handleSubmit() {
    if (!title || !schedule) {
      alert("Por favor, preencha o título e a data/hora da reunião.");
      return;
    }

    setLoading(true);

    try {
      let updatedPostList = [];

      const updatedPost = {
        id: state.id,
        createdAt: state.id,
        updatedAt: Date.now(),
        proId: userData.id,
        proName: userData.displayName,
        title,
        description,
        groupId: state.groupId,
        scheduleFor: schedule,
        jitsiRoomName: state.jitsiRoomName,
        meetingUrl: meetingUrl,
        participants: participants,
        notes: "",
        status: status,
        type: meetingType,
        moderatorOnline: moderatorOnline,
      };

      // 🔹 grava no Firestore
      await setDoc(doc(db, "meetings", updatedPost.id), updatedPost);

      alert("Reunião atualizada com sucesso!");
      navigate("/admin");
    } catch (error) {
      console.error("Erro ao criar reunião:", error);
      alert("Ocorreu um erro ao criar a reunião.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className={css.container}>
      <Head title="Editar Reunião" description="Editar reunião - Ibhava" />
      <h2 className={css.title}>Editar Reunião</h2>
      <small>{state.title}</small>
      <div className={css.controlsMeeting}>
        <div>
          <p>ModeratorOnline: </p>
          <label className={css.axis}>
            True
            <input
              type="checkbox"
              checked={moderatorOnline ? true : false}
              onChange={() => {
                setModeratorOnline(true);
              }}
            />
            <span className={css.checkmark}></span>
          </label>
          <label className={css.axis}>
            False
            <input
              type="checkbox"
              checked={!moderatorOnline ? true : false}
              onChange={() => {
                setModeratorOnline(false);
              }}
            />
            <span className={css.checkmark}></span>
          </label>
        </div>

        <div>
          <p>Status: </p>
          <label className={css.axis}>
            scheduled
            <input
              type="checkbox"
              checked={status === "scheduled" ? true : false}
              onChange={() => {
                setStatus("scheduled");
              }}
            />
            <span className={css.checkmark}></span>
          </label>
          <label className={css.axis}>
            done
            <input
              type="checkbox"
              checked={status === "done" ? true : false}
              onChange={() => {
                setStatus("done");
              }}
            />
            <span className={css.checkmark}></span>
          </label>
        </div>

        <div>
          <p>Tipo: </p>
          <label className={css.axis}>
            consultation
            <input
              type="checkbox"
              checked={meetingType === "consultation" ? true : false}
              onChange={() => {
                setMeetingType("consultation");
              }}
            />
            <span className={css.checkmark}></span>
          </label>
          <label className={css.axis}>
            health
            <input
              type="checkbox"
              checked={meetingType === "health" ? true : false}
              onChange={() => {
                setMeetingType("health");
              }}
            />
            <span className={css.checkmark}></span>
          </label>
          <label className={css.axis}>
            supervision
            <input
              type="checkbox"
              checked={meetingType === "supervision" ? true : false}
              onChange={() => {
                setMeetingType("supervision");
              }}
            />
            <span className={css.checkmark}></span>
          </label>
        </div>
      </div>

      <Input
        type="text"
        name="title"
        placeholder="Título"
        label="Título"
        value={title}
        required
        className={css.inputText}
        onChange={(e) => setTitle(e.target.value)}
        autoComplete="off"
      />

      <Input
        type="text"
        name="url"
        placeholder="Url"
        label="Url"
        value={meetingUrl}
        required
        className={css.inputText}
        onChange={(e) => setMeetingUrl(e.target.value)}
        autoComplete="off"
      />

      <InputArea
        type="text"
        name="description"
        placeholder="description"
        label="description"
        value={description}
        required
        className={css.inputText}
        onChange={(e) => setDescription(e.target.value)}
        autoComplete="off"
      />

      <Input
        type="datetime-local"
        name="schedule"
        label="Data e hora"
        value={schedule}
        required
        className={css.inputText}
        onChange={(e) => setSchedule(e.target.value)}
      />

      <label className={css.inputText}>Participantes</label>

      <div className={css.tagsContainer}>
        {participants.map((email, index) => (
          <div key={index} className={css.tag}>
            {email}
            <span
              className={css.removeTag}
              onClick={() =>
                setParticipants(participants.filter((_, i) => i !== index))
              }
            >
              ×
            </span>
          </div>
        ))}

        <input
          type="text"
          className={css.tagsInput}
          placeholder="Digite um email e pressione Enter"
          value={participantInput}
          onChange={(e) => setParticipantInput(e.target.value)}
          onKeyDown={handleTagKeyDown}
        />
      </div>

      <div className={css.footer}>
        <button
          className="saveButton"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Salvando..." : "Salvar"}
        </button>
      </div>
    </div>
  );
};
